import cx from 'classnames'
import { FC } from 'react'
import { motionSlide } from 'src/hooks/useAppear'

import { IllustrationProps } from '../Illustration'

import * as SC from './styled'

export type IllustrationPushProps = IllustrationProps & {
  className?: string
}

const IllustrationPush: FC<IllustrationPushProps> = ({
  className,
  ...props
}) => {
  const { motionProps } = motionSlide({})

  return (
    <>
      <SC.ContainerDesktop
        className={cx('IllustrationPush', className)}
        {...props}
        {...motionProps}
      />
      <SC.ContainerMobile
        className={cx('IllustrationPush', className)}
        {...props}
      />
    </>
  )
}

export default IllustrationPush
